import React, { useCallback, useEffect, useRef, useState } from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import TransactionList from '../components/transactions/transactionList'

interface Props {
	userId: string
}

const UserTransactions: React.FC<Props> = ({ userId }) => {
	const [transactions, setTransactions] = useState<any[]>([])
	const [pageIndex, setPageIndex] = useState(0)
	const [pageDirection,] = useState<'desc' | 'asc'>('desc')

	const lastTransactionDate = useRef(new Date())

	useEffect(
		() => {
			let ref = firebase.firestore().collection('transactions')
				.where('userId', '==', userId)
				.orderBy('transactionDate', pageDirection)
				.startAfter(lastTransactionDate.current)

			const sub = ref
				.limit(100)
				.onSnapshot(snap => {
					if (snap.size > 0) {
						lastTransactionDate.current = snap.docs[snap.size - 1].data().transactionDate.toDate()
					}

					const t = snap.docs.map(d => ({ ...d.data(), id: d.id }))
					setTransactions(prev => [...prev, ...t])
				})

			return sub
		},
		[pageDirection, pageIndex, userId],
	)

	const handleShowMore = useCallback(
		(ix) => {
			lastTransactionDate.current = transactions[transactions.length - 1].transactionDate.toDate()
			setPageIndex(pageIndex + 1)
		},
		[pageIndex, transactions],
	)

	if (transactions.length === 0) {
		return (
			<div className="flex flex-col container mt-4 mx-auto">
				<div className="bg-white shadow-xs p-4 text-sm text-gray-800 rounded">
					Nothing to see here
				</div>
			</div>
		)
	}

	return (
		<div className="flex flex-col container mt-6 mx-auto">
			<div>
			</div>
			<div className="bg-white shadow-xs rounded">
				<TransactionList transactions={transactions} />
			</div>
			<div className="mt-4">
				<button onClick={handleShowMore} className="py-1 bg-transparent text-gray-400 border-2 border-gray-400">Show more</button>
			</div>
		</div>
	)
}

export default UserTransactions
